enum TipoConviteEnum {
  MedicoAgendamento = 'MedicoAgendamento',
  SecretariaAgendamento = 'SecretariaAgendamento',
}
export default TipoConviteEnum
